export const TYPE_TUTORIAL = 1; // 只有教程
export const TYPE_CODE = 2; // 激活码类型
export const TYPE_DEVICE = 3; // 硬件类型没有激活码
export const TYPE_DEVICE_WITH_CODE = 4; // 教程、硬件、激活码均有
export const TYPE_DEVICE_WITH_JOIN = 5; // 教程、加入社群

const config = {
  1: {
    title: 'x86专业版',
    type: TYPE_CODE,
    component: 'X86',
    footerNav: {
      tutorial: 'https://help.yfanqie.com/1f8d/1ea8',
      buy: '/mall/xcode/1',
    },
  },
  2: {
    title: '赚钱宝电脑版',
    type: TYPE_TUTORIAL,
    component: 'X86Lite',
    footerNav: {
      tutorial: 'https://www.yfanqie.com/products/x86-lite/',
    },
    join: {
      groupName: '网心云赚钱宝电脑版交流群',
      imgName: 'pc',
    },
  },
  3: {
    title: '玩客云现金版',
    type: TYPE_DEVICE_WITH_CODE,
    component: 'OnecloudCash',
    footerNav: {
      tutorial: 'https://help.yfanqie.com/caa9/8076',
      buy: '/mall/xcode/3',
      hardware:
        'https://shop90316740.m.youzan.com/v2/feature/nw0nCQRDsJ?dc_ps=2562972625131507721.200001',
    },
  },
  5: {
    title: '小爱盒子',
    type: TYPE_CODE,
    component: 'XiaoAiBox',
    footerNav: {
      tutorial: 'https://help.yfanqie.com/caa9/0ae7/51b3',
      buy: '/mall/xcode/5',
    },
  },
  7: {
    title: '三方盒子',
    type: TYPE_CODE,
    component: 'SFBox',
    footerNav: {
      tutorial: 'https://help.yfanqie.com/caa9/bd32',
      buy: '/mall/xcode/7',
    },
  },
  1000: {
    title: '赚钱宝3代Pro',
    type: TYPE_TUTORIAL,
    component: 'OnecloudPro3',
    footerNav: {
      tutorial: 'https://help.yfanqie.com/caa9/e099',
      hardware:
        'https://shop90316740.m.youzan.com/v2/feature/nw0nCQRDsJ?dc_ps=2562972625131507721.200001',
    },
    join: {
      groupName: '网心云赚钱宝交流群',
      imgName: 'zqb',
    },
  },
  1003: {
    title: '赚钱宝3代',
    type: TYPE_DEVICE,
    component: 'Zqb3',
    footerNav: {
      tutorial: 'https://help.yfanqie.com/caa9/wky',
      hardware:
        'https://shop90316740.m.youzan.com/v2/feature/nw0nCQRDsJ?dc_ps=2562972625131507721.200001',
    },
  },
  1005: {
    title: '容器魔方',
    type: TYPE_TUTORIAL,
    component: 'Container',
    footerNav: {
      tutorial: 'https://help.yfanqie.com/caa9/b6b3',
    },
    join: {
      groupName: '网心云容器魔方交流群',
      imgName: 'container',
    },
  },
  1002: {
    title: '树莓派',
    type: TYPE_TUTORIAL,
    component: 'RPI',
    footerNav: {
      tutorial: 'https://help.yfanqie.com/7cb4/3ed5/39ae',
    },
    join: {
      groupName: '网心云三方硬件交流群',
      imgName: 'rpi',
    },
  },
  1006: {
    title: '纳思小星',
    type: TYPE_TUTORIAL,
    component: 'Nas',
    footerNav: {
      tutorial: 'https://help.yfanqie.com/caa9/nasxx',
    },
    join: {
      groupName: '网心云纳思小星交流群',
      imgName: 'nas',
    },
  },
  1007: {
    title: '福利码-玩客云/赚3',
    type: TYPE_CODE,
    component: 'WelfareCard',
    footerNav: {
      tutorial: 'https://help.yfanqie.com/caa9/flm',
      buy: '/mall/xcode/11',
      hardware: 'https://j.youzan.com/U4gcNe?is_third=true',
    },
  },
  1009: {
    title: '福利码-OES系列',
    type: TYPE_CODE,
    component: 'WelfareCard',
    footerNav: {
      tutorial: 'https://help.onethingcloud.com/caa9/1e2a',
      buy: '/mall/xcode/18',
      hardware: 'https://j.youzan.com/U4gcNe?is_third=true',
    },
  },
  1010: {
    title: '福利码-OEC系列',
    type: TYPE_CODE,
    component: 'WelfareCard',
    footerNav: {
      tutorial: 'https://help.onethingcloud.com/caa9/1e2a',
      buy: '/mall/xcode/17',
      hardware: 'https://j.youzan.com/U4gcNe?is_third=true',
    },
  },
};

export default config;
